export default "__VITE_ASSET__07148a94__"